import TemplateGlobal from '@src/components/Layout/TemplateGlobal'
import SelectedCompanyProvider from '@src/providers/SelectedCompanyProvider'
import type { JSX } from 'react'
import { createBrowserRouter, createRoutesFromElements, Navigate, Route, RouterProvider } from 'react-router-dom'
import AdminRouter from './Admin/AdminRouter'
import InteracHistoryRouter from './InteracHistory/InteracHistoryRouter'
import InteracWireRouter from './InteracWire/InteracWireRouter'
import LoansRouter from './Loans/LoansRouter'

// https://reactrouter.com/6.30.1/routers/picking-a-router
const router = createBrowserRouter(
  createRoutesFromElements(
    <Route>
      <Route element={<SelectedCompanyProvider />}>
        <Route element={<TemplateGlobal />}>
          <Route path="/" element={<Navigate to="/loans" replace />} />
          <Route path="/loans/*" element={<LoansRouter />} />
          <Route path="/interac-wire/*" element={<InteracWireRouter />} />
          <Route path="/interac-history/*" element={<InteracHistoryRouter />} />
          <Route path="/admin/*" element={<AdminRouter />} />
        </Route>
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Route>,
  ),
)

const Router = (): JSX.Element => {
  return <RouterProvider router={router} />
}

export default Router
